module.exports = __webpack_public_path__ + "static/media/28-1.e314ded9.mp3";